import en from './en';
import zh from './zh';
import es from './es';
import de from './de';
import id from './id';
import tr from './tr';

export default {
  en,
  zh,
  es,
  de,
  id,
  tr,
};
